import * as UserActionTypes from '../constants/user/ActionTypes';
import update from 'immutability-helper'
const initialState = window.Config.user;

export default (state = initialState, action) => {
	switch (action.type) {
        case UserActionTypes.UPDATE_ROLE:
            return update(state, {
                role: {
                    $set: action.role
                }
            });
        default:
			return state
	}
}
